// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__PK0km","bookingInfo":"TimeRange_bookingInfo__50yP9","dateSection":"TimeRange_dateSection__3R_n7"};